module.exports = __webpack_public_path__ + "img/mediumAfsorder.f17bce1e.svg";